import EmbedChunk from './EmbedChunk';

export default EmbedChunk;
